import { fonts as menuFonts } from 'shared/constants/menu-fonts';
import { defaultTagColors } from 'shared/constants/menu-colors';
import { isColorDark, getTextTransformStyle, getRadiusStyle } from '../../helpers';
import { PreviewTheme, PreviewData } from './preview.types';
import { nonLocalFonts } from '../../fonts/fonts.constants';

type UsePreviewReturn = {
  theme: PreviewTheme;
  encodedFonts: string;
};

export function usePreview(data: PreviewData): UsePreviewReturn {
  const { fontSettings, colors, fonts, textTransforms, radius } = data;
  const { navBar, buttonsLinks, staffPickTag, discountTag, productCardButton } = colors;
  const { heading, body } = fonts;
  const { buttons, links, tags } = textTransforms;

  const font = menuFonts[fontSettings.family];

  const theme = {
    isNavColorDark: isColorDark(navBar),
    navColor: navBar,
    linkColor: buttonsLinks,
    staffPickTagColor: staffPickTag ?? defaultTagColors.staffPick,
    discountTagColor: discountTag ?? defaultTagColors.discount,
    productCardButton,
    fontFamily: font.fontFamily,
    secondaryFont: `'${body}'`,
    primaryFont: `'${heading}'`,
    textTransforms: {
      buttons: getTextTransformStyle(buttons),
      links: getTextTransformStyle(links),
      tags: getTextTransformStyle(tags),
    },
    radius: getRadiusStyle(radius.default),
  };

  // Return only google fonts correctly encoded to include in stylesheet request
  const selectedFonts = new Set(nonLocalFonts.filter((fontOption) => [body, heading].includes(fontOption.fontFamily)));
  const encodedFonts = Array.from(selectedFonts)
    .map((fontOption) => `family=${fontOption.fontFamilyEncoded}`)
    .join('&');

  return {
    theme,
    encodedFonts,
  };
}
